export default __webpack_public_path__ + "static/single-leaf-nogap-904d364a1d5a2644d7302c5ea233209e.png";